import type * as React from "react";
import { Header } from "@/shared/ui/header/Index.tsx";
import {
  buttons,
  container,
  header,
  headingAndSupportingText,
  paragraph,
  wrapper,
} from "./Styles.css.ts";

export const Wrapper: React.FC<{
  heading: string;
  description: React.ReactNode;
  buttons?: React.ReactNode;
  icon: React.ReactNode;
  iconPosition?: "above" | "below";
  showHeader?: boolean;
}> = ({
  heading,
  description,
  buttons: buttonElements,
  icon,
  iconPosition = "above",
  showHeader = true,
}) => (
  <>
    {showHeader ? <Header /> : null}
    <main className={wrapper}>
      <div className={container({ iconPosition })}>
        <div>
          <div className={headingAndSupportingText}>
            <h1 className={header}>{heading}</h1>
            <p className={paragraph}>{description}</p>
          </div>
          {buttonElements ? (
            <div className={buttons}>{buttonElements}</div>
          ) : null}
        </div>
        <div>{icon}</div>
      </div>
    </main>
  </>
);
